var __jsx = React.createElement;
import classNames from "classnames";
import { every, get } from "lodash";
import React from "react";
import EditDetailsModal from "../EditDetailsModal";
import { formatDate } from "../../../utils";
import { t } from "i18next";
import AwesomeIcon from "../../AwesomeIcon";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
function MobileFilesList(props) {
  var onChangeRowData = props.onChangeRowData,
    invalidFileError = props.invalidFileError,
    onEditData = props.onEditData,
    resetDetails = props.resetDetails,
    setPatientDetail = props.setPatientDetail,
    formattedSelectedFiles = props.formattedSelectedFiles,
    unSelect = props.unSelect,
    setEditRowId = props.setEditRowId,
    setIsEditModalOpen = props.setIsEditModalOpen,
    error = props.error,
    isEditModalOpen = props.isEditModalOpen,
    patientDetail = props.patientDetail;
  var selectedFilesKeys = Object.keys(formattedSelectedFiles);
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-6 sm:hidden"
  }, selectedFilesKeys.map(function (fileKey, index) {
    var fileObject = formattedSelectedFiles[fileKey];
    var patientId = get(fileObject, [0, "metaData", "PatientID"], "");
    var patientName = get(fileObject, [0, "metaData", "PatientName"], "");
    var modality = get(fileObject, [0, "metaData", "Modality"], "");
    var studyDate = get(fileObject, [0, "metaData", "StudyDate"], "");
    var isSelected = every(fileObject, ["isSelected", true]);
    var isValidated = every(fileObject, ["isValidated", true]);
    var patientGender = get(fileObject, [0, "metaData", "PatientGender"], "");
    var patientAge = get(fileObject, [0, "metaData", "PatientAge"], "");
    var seriesInstanceUID = get(fileObject, [0, "metaData", "SeriesInstanceUID"], "");
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classNames("border text-md border-gray-600 rounded-md overflow-hidden", {
        "border-teal-500": isSelected
      }),
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("border-b border-gray-600 flex justify-between items-center px-5 py-3 bg-gray-800", {
        "bg-teal-800 border-teal-500": isSelected
      })
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-300 text-ellipsis whitespace-nowrap overflow-hidden"
    }, patientName, " | ", patientId), /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "rounded accent-gray-300 checked:!bg-teal-400 cursor-pointer",
      disabled: !isValidated,
      checked: isSelected,
      onChange: function onChange(e) {
        return unSelect(e, fileObject);
      }
    })), /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classNames("text-left relative p-5 space-y-3", {
        "!opacity-50": !isSelected && isValidated
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("study_details")), /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md"
    }, formatDate(studyDate))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("series_instance")), /*#__PURE__*/React.createElement("div", {
      className: "col-span-2 items-center flex space-x-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-md"
    }, "".concat(modality)), /*#__PURE__*/React.createElement("div", {
      className: "flex space-x-2 items-center text-gray-700 dark:text-gray-500"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCopy,
      size: "xs"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-md"
    }, fileObject === null || fileObject === void 0 ? void 0 : fileObject.length)))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("status")), /*#__PURE__*/React.createElement("div", {
      className: "col-span-2"
    }, invalidFileError(fileObject))), isSelected && /*#__PURE__*/React.createElement("button", {
      disabled: Object.values(error).filter(function (err) {
        return err.length > 0;
      }).length > 0,
      onClick: function onClick() {
        setEditRowId(seriesInstanceUID);
        setPatientDetail({
          patientName: patientName,
          patientId: patientId,
          patientAge: patientAge,
          patientGender: patientGender
        });
        setIsEditModalOpen(true);
      },
      className: "text-teal-300 text-md absolute right-6 bottom-5 font-medium"
    }, t("edit_key")))), /*#__PURE__*/React.createElement(EditDetailsModal, {
      isVisible: isEditModalOpen,
      title: "Edit patient",
      onClose: resetDetails,
      patient: patientDetail,
      onEditData: onEditData,
      onChangeRowData: onChangeRowData,
      error: error
    }));
  }));
}
export default MobileFilesList;